import React, { Component } from 'react'
import IssuesModel from '../models/IssuesModel'
import ProgramsModel from '../models/ProgramsModel'
import TemplatesModel from '../models/TemplatesModel'
import { Row, Col, Form, Modal, Button } from 'antd'
import SimpleIssueStep1 from './SimpleIssueStep1'
import SimpleIssueStep2 from './SimpleIssueStep2'
import SimpleIssueStep3 from './SimpleIssueStep3'
import SimpleIssueStep4 from './SimpleIssueStep4'
import LoadingComponent from './Loading'
import config from 'react-observable-store'

class PublicSimpleForm extends Component {

    constructor(props) {
        super(props)
        this.initValidation = this.initValidation.bind(this)
        this.onChangeField = this.onChangeField.bind(this)
        this.onUploadAttach = this.onUploadAttach.bind(this)
        this.onRemoveAttach = this.onRemoveAttach.bind(this)
        this.onRemoveTempAttach = this.onRemoveTempAttach.bind(this)
        this.onSaveForm = this.onSaveForm.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
        this.loading = this.loading.bind(this)

        // Init map
        this.map = IssuesModel.createMap(config.get('globals').olmap1, props.data.mapCenter, props.data.mapZoom)

        // Register events
        this.map.on('moveend', () => {
            this.props.changeMapCenter(
                this.map.getView().getCenter(),
                this.map.getView().getZoom()
            )
        })

        // Init UI form state
        this.state = {
            ...this.props.data,
            loading: false,
            praias: [],
            newAttach: [],
            programs: [],
            user: this.props.data.id ? this.props.data.tecnico
                : (this.props.auth.username ? this.props.auth.username : IssuesModel.generateAnonymousId()),
            entidade: this.props.data.id ? this.props.data.entidade
                : (this.props.auth.entidade ? this.props.auth.entidade : ''),
            v: this.initValidation(),
            modalInfo: true,
            putMarker: false,
            issue_type_options: [],
            data_source_options: []
        }
    }

    loadOptions() {
        this.loading()
        ProgramsModel.findAllActive((programs) => {
            TemplatesModel.find('politica_privacidade.html', (template) => {
                IssuesModel.getIssueTypeOptions(options1 => {
                    IssuesModel.getDataSourceOptions(options2 => {
                        var state = Object.assign({}, this.state)
                        state.issue_type_options = options1
                        state.data_source_options = options2
                        state.programs = programs
                        state.policy_text = template.content.replace(/\r?\n/g, "<br />")
                        state.loading = false
                        this.setState(state)
                    });
                });
            });
        });
    }

    componentDidMount() {
        this.loadOptions()
    }

    loading(toggle = true) {
        var state = Object.assign({}, this.state)
        state.loading = toggle
        this.setState(state)
    }

    initValidation() {
        return {
            show: false,
            freguesia: {rule: 'required', msg: ''},
            tipo: {rule: 'required', msg: ''}
        }
    }

    componentWillReceiveProps(nextProps) {
        var formData = {
            ...this.state,
            id: nextProps.data.id ? nextProps.data.id : this.state.id,
            data_registo: nextProps.data.data_registo ? nextProps.data.data_registo : this.state.data_registo,
            mapCenter: nextProps.data.mapCenter,
            mapZoom: nextProps.data.mapZoom,
            dicofre: nextProps.caop ? nextProps.caop.dicofre || '' : this.state.dicofre,
            freguesia: nextProps.caop ? nextProps.caop.freguesia || '' : this.state.freguesia,
            concelho: nextProps.caop ? nextProps.caop.concelho || '' : this.state.concelho,
            distrito: nextProps.caop ? nextProps.caop.distrito || '' : this.state.distrito,
            arh_cod: nextProps.caop ? nextProps.caop.arh_cod || '' : this.state.arh_cod,
            arh: nextProps.caop ? nextProps.caop.arh || '' : this.state.arh,
            praias: nextProps.caop && nextProps.caop.praias ? nextProps.caop.praias : this.state.praias,
            attachments: nextProps.data.attachments,
            submitdate: nextProps.data.submitdate,
            status: nextProps.data.status,
            loading: false,
            attach_a: nextProps.data.attach_a,
            putMarker: false,
            issue_date: nextProps.data.issue_date,
            issue_time: nextProps.data.issue_time,
            issue_reg_local_date: nextProps.data.issue_reg_local_date,
            issue_reg_local_time: nextProps.data.issue_reg_local_time
        }
        this.setState(formData)
    }

    onChangeField(field, value) {
        const formData = Object.assign({}, this.state)
        formData[field] = value

        // On change program
        if (field === 'programa_id') {
            let programs = this.state.programs || [];
            let choosen_program = programs.filter(p => ''+p.id === value)
            if (choosen_program.length && choosen_program[0].locals.length) {

                // Get first local as default
                var local = choosen_program[0].locals[0];
                formData['mapCenter'] = [local.x, local.y];
                formData['mapZoom'] = 14;
                formData['address'] = local.address;
                formData.putMarker = true;
            }
        }
        this.setState(formData)
    }

    onSaveForm() {
        const formData = Object.assign({}, this.state)
        formData['status'] = formData['status'] ? formData['status'] : 'Guardada';
        formData['step'] = this.props.step
        this.props.storeForm(formData)
        formData['loading'] = true
        this.setState(formData)
    }

    onSubmit() {
        const formData = Object.assign({}, this.state)
        formData['status'] = 'Submetida'
        formData['step'] = this.props.step
        this.props.submitForm(formData)
        formData['loading'] = true
        this.setState(formData)
    }

    onRemoveAttach(item) {
        this.props.removeAttach(item)
        const formData = Object.assign({}, this.state)
        formData.attachments = formData.attachments.filter((attach) => {
            return attach.id === item.id ? false : true
        })
        this.setState(formData)
    }

    onRemoveTempAttach(filename) {
        var attach = false
        this.state.newAttach.forEach((item) => {
            if (filename === item.name) attach = item
        })
        this.props.removeTempAttach(attach)
        const formData = Object.assign({}, this.state)
        formData.newAttach = formData.newAttach.filter((item) => {
            return filename === item.name ? false : true
        })
        this.setState(formData)
    }

    onUploadAttach(item) {
        const formData = Object.assign({}, this.state)
        formData.newAttach.push(item)
        this.setState(formData)
    }

    handleOk = (e) => {
        this.setState({
            ...this.state,
            modalInfo: false
        });
    }

    handleCancel = (e) => {
        this.props.history.push('/');
    }

    showModal = (e) => {
        this.setState({
            ...this.state,
            modalInfo: true
        });
    }

    render() {
        const stepClassName = (step) => {
            return 'visible';
        }
        if (this.state.loading) return (<LoadingComponent />)
        return (
            <div>
                <Form onSubmit={this.props.handleSubmit}>
                    
                    <Row style={{marginTop: '24px'}}>
                        <Col span={24}>
                            <SimpleIssueStep1 {...this.state}
                                className={stepClassName(0)}
                                onChangeField={this.onChangeField}
                            />
                            <SimpleIssueStep2 {...this.state}
                                className={stepClassName(1)}
                                map={this.map}
                                gmapsGeocoder={this.props.gmapsGeocoder}
                                changeMapCenter={this.props.changeMapCenter}
                                onChangeField={this.onChangeField}
                                getDeviceGeolocation={this.props.getDeviceGeolocation}
                            />
                            <SimpleIssueStep3 {...this.state}
                                className={stepClassName(2)}
                                onChangeField={this.onChangeField}
                                onUploadAttach={this.onUploadAttach}
                                onRemoveAttach={this.onRemoveAttach}
                                onRemoveTempAttach={this.onRemoveTempAttach}
                            />
                            <SimpleIssueStep4 {...this.state}
                                loading={this.loading}
                                complete={this.props.complete}
                                error={this.props.error}
                                className={stepClassName(3)}
                                onChangeField={this.onChangeField}
                                onSaveForm={this.onSaveForm}
                                onSubmit={this.onSubmit}
                                resetForm={this.props.resetForm}
                                history={this.props.history}
                                showModal={this.showModal.bind(this)}
                            />
                            
                        </Col>
                    </Row>
                    
                </Form>

                <Modal
                    title="Política de Privacidade"
                    visible={this.state.modalInfo}
                    maskClosable={false}
                    closable={false}
                    cancelText={null}
                    footer={[
                        <Button key="back" type="danger" size="large" onClick={this.handleCancel}>Sair</Button>,
                        <Button key="submit" type="primary" size="large" onClick={this.handleOk}>
                            Continuar
                        </Button>,
                    ]}
                    >
                    <div dangerouslySetInnerHTML={{ __html: this.state.policy_text }}></div>
                </Modal>
            </div>
        )
    }
}

export default PublicSimpleForm;



// WEBPACK FOOTER //
// ./src/components/PublicSimpleForm.js